import {Injectable} from '@angular/core';
import {ApiVersion} from '../constants/apis';
import {AbstractService} from './abstract.service';
import {
  Category,
  DeletionDomainResponse, DeletionLibraryResponse,
  PurgeDomainJob,
  PurgeLibraryJob,
  ReportDetails
} from '../models/reporting.model';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PolicyType} from "../constants/retention-constants";
import {UserService} from './user.service';

@Injectable({
  providedIn: 'root'
})
export class ReportingService extends AbstractService {

  constructor(private readonly http: HttpClient,
              private readonly userService: UserService) {
    super();
  }

  loadLatestWarnNotificationReportDetails(retentionType: PolicyType): Observable<ReportDetails> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'report/warning/latest');
    const params = new HttpParams().set('retentionType', retentionType);
    return this.http.get<ReportDetails>(url, {params});
  }

  exportRetentionBindings(policyId: string): Observable<void> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'reporting/export/retention-bindings');
    const initiator = this.userService.user?.email;

    const body = {
      initiator: initiator ?? '',
      policyId
    };

    return this.http.post<void>(url, body, {responseType: 'text' as 'json'});
  }

  listRecordCategories(libraryId: string): Observable<Category[]> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, `libraries/${libraryId}/record-category-values`);
    return this.http.get<Category[]>(url);
  }

  exportDocsToBeDeleted(startDate: string,
                        endDate: string,
                        recordCategoryId: string,
                        libraryId: string,
                        initiator: string,
                        performStandardReport: boolean,
                        performFinraReport: boolean): Observable<void> {

    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'report/warning');

    const reportTypes: string[] = [];
    if (performStandardReport) {
      reportTypes.push(PolicyType.STANDARD);
    }
    if (performFinraReport) {
      reportTypes.push(PolicyType.FINRA);
    }

    const params = {startDate, endDate, recordCategoryId, libraryId, initiator,
      reportTypes};
    return this.http.post<void>(url, params);
  }

  listDomainPurgeJobs(retentionType: string): Observable<DeletionDomainResponse> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'report/deletion/domain-jobs/' + retentionType);
    return this.http.get<DeletionDomainResponse>(url);
  }

  listLibraryPurgeJobsUnderDomainPurgeJob(deletionDomainJobId: string): Observable<DeletionLibraryResponse> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'report/deletion/' + deletionDomainJobId + '/library-jobs');
    return this.http.get<DeletionLibraryResponse>(url);
  }

  exportDeletedDocsForLibraryJob(domainJobId: string, libraryJobId: string): Observable<void> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'report/deletion/library-jobs/' + libraryJobId + '/export');
    return this.http.get<void>(url);
  }

  exportDeletedDocsForDomainJob(domainJobId: string): Observable<void> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'report/deletion/domain-jobs/' + domainJobId + '/export');
    return this.http.get<void>(url, {});
  }

}
